export default {
    selector: '.f-three-columns-posts-slider',
    nextBtnSelector: '.f-three-columns-posts-slider__next',
    prevBtnSelector: '.f-three-columns-posts-slider__prev',
    args: {
        prevNextButtons: false,
        contain: true,
        autoplay: false,
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
        draggable: false,
        groupCells: true,
        cellAlign: 'left',
    }
}